import { render, staticRenderFns } from "./ChangelogEntryCategory.vue?vue&type=template&id=00cb5524&scoped=true&"
import script from "./ChangelogEntryCategory.vue?vue&type=script&lang=ts&"
export * from "./ChangelogEntryCategory.vue?vue&type=script&lang=ts&"
import style0 from "./ChangelogEntryCategory.vue?vue&type=style&index=0&id=00cb5524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cb5524",
  null
  
)

export default component.exports